import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import { useNodeById } from '@/stores/analysisStore';
import { FormProvider } from 'react-hook-form';
import LevelizationForm from '@/components/core/LevelizationForm';
import { useEffect } from 'react';
import debounce from 'debounce';
import { ModuleSelect } from '@/components/core/form/ModuleSelect';

const CharacteristicsForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({
    defaultValues,
  });

  const { handleSubmit, control, watch } = methods;

  const [nodeId, levelizeBy, levelizeUnit, levelizableIos] = useWatch({
    control,
    name: ['nodeId', 'levelizeBy', 'levelizeUnit', 'levelizableIos'],
    defaultValue: defaultValues,
  });

  const node = useNodeById(nodeId);

  const debouncedSubmit = debounce(() => handleSubmit(onSubmit)(), 10);

  useEffect(() => {
    const subscription = watch(debouncedSubmit);
    return () => subscription.unsubscribe();
  }, [watch, debouncedSubmit]);

  return (
    <FormProvider {...methods}>
      <div className="group node">
        <form>
          <div className="mt-2 grid grid-cols-6 gap-2">
            <ModuleSelect />
            <LevelizationForm
              node={node}
              levelizableIos={levelizableIos}
              levelizeBy={levelizeBy}
              levelizeUnit={levelizeUnit}
            />
          </div>
        </form>
      </div>
    </FormProvider>
  );
};

CharacteristicsForm.propTypes = {
  params: PropTypes.arrayOf(PropTypes.object),
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default CharacteristicsForm;
